import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CopyOutlined } from "@ant-design/icons";
import { DownloadOutlined } from "@ant-design/icons";
import {
  useEffect,
  useState,
  React,
  Pagination,
  Alert,
  message,
  Spin,
  exportFromJSON,
  axios,
  moment,
  DatePicker,
} from "./import";

const { RangePicker } = DatePicker;
const TinAssign = ({
  getTinData,
  candidateId,
  disableTinArrangeButton,
  setTinOptions,
}) => {
  //component is placed in candidate single interview (Lovejot)

  const [modal, setModal] = useState(false);
  const [toggleModal, setToggleModal] = useState(false);
  const [tin, setTin] = useState();
  const [reason, setReason] = useState("");
  const [tinReport, setTinReport] = useState([]);
  const [error, setError] = useState("");
  const [errorRequestTin, setErrorRequestTin] = useState("");
  const [load, setLoad] = useState(false);
  const [current, setCurrent] = useState(1);
  const [defaultDate, setDefaultDate] = useState([]);
  const [tinType, setTinType] = useState("");

  const disabledDate = (current) => {
    // 90 DAYS GAP AND DISABLE TOMORROW
    return (
      current.isBefore(moment().subtract(90, "day")) ||
      current > moment().endOf("day")
    );
  };

  //DATE FILTER
  const handleDate = (value, dateString) => {
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setDefaultDate(dateString);
    }
  };

  useEffect(() => {
    // getRandomTin();
    // getTinReport();
  }, []);

  useEffect(() => {
    getTinData(tin?._id);
  }, [tin]);

  const onChange = (page) => {
    setCurrent(page);
    getTinReport(page);
  };

  const getRandomTin = () => {
    setLoad(true);
    axios
      .get(
        "/manageTin/RandomTin/" +
          localStorage.getItem("user.id") +
          "/TinType/Voice",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res, err) => {
        if (res.status === 200) {
          setError("");
          disableTinArrangeButton("");
          getTinReport();
          setTin(res.data.status);
        }
      })
      .catch((err) => {
        disableTinArrangeButton(err?.response?.data?.status);
        message.error(err?.response?.data?.status, 5);
        setError(err?.response?.data?.status);
      })
      .finally(() => {
        setLoad(false);
      });
  };

  const getTinReport = (page) => {
    axios
      .get(
        `/manageTin/${localStorage.getItem("user.id")}?PageNo=${
          page ? page : current
        }&PageSize=10`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        setTinReport(res.data);
      });
  };

  const requestNewTin = () => {
    if (!reason) {
      setErrorRequestTin("Please Select Reason!");
    } else {
      axios
        .put(
          "/manageTin/RequestNewTin",
          {
            TinId: tin._id,
            UserId: localStorage.getItem("user.id"),
            Reason: reason,
            CandidateId: candidateId,
            TinType: tinType
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            setTin(res.data.status);
            getTinReport();
            toggle();
            message.success("New TIN generated successfully!", 5);
          }
        })
        .catch((err) => {
          console.error(err);
          message.error(err.response.data.status, 5);
          setErrorRequestTin(err.response.data.status);
        });
    }
  };

  const selectReason = (e) => {
    setErrorRequestTin("");
    setReason(e.target.value);
  };

  const toggle = (e) => {
    setReason("");
    setErrorRequestTin("");
    const countClicked = e?.target.getAttribute("countData");
    const tinReq = e?.target.getAttribute("tinReq");
    if (countClicked) {
      setToggleModal(true);
    } else if (tinReq) {
      setToggleModal(false);
    }
    setModal(!modal);
  };

  const exportType = "csv";

  function formatDate(d) {
    let date = new Date(d);
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return (d =
      dd + "/" + mm + "/" + yyyy + " " + hours + ":" + minutes + ":" + seconds);
  }

  const downloadSingleUserReport = () => {
    axios
      .get(
        `manageTin/Reports/TinUsage/${localStorage.getItem(
          "user.id"
        )}?StartDate=${
          defaultDate[0]
            ? defaultDate[0]
            : moment(new Date()).format("YYYY-MM-DD")
        }&EndDate=${
          defaultDate[1]
            ? defaultDate[1]
            : moment(new Date()).format("YYYY-MM-DD")
        }`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        const tinFormat = res?.data?.tinList?.map((ele) => {
          return {
            name: ele?.assignUserId?.name,
            candidate_name: ele?.candidateId?.name,
            email: ele?.assignUserId.email,
            tin: ele?.tinNo,
            TIN_status: ele.tinStatus ? "Active" : "inActive",
            reason: ele?.RequestReason,
            assign_date: ele?.assignDate ? formatDate(ele?.assignDate) : "",
            used_date: ele?.usedDate ? formatDate(ele?.usedDate) : "",
            trf: ele?.candidateId?.trf?.title,
            location: ele?.candidateId?.trf?.location,
            process: ele?.candidateId?.trf?.processName,
            createdAt: ele?.createdAt ? formatDate(ele?.createdAt) : "",
            updatedAt: ele?.updatedAt ? formatDate(ele?.updatedAt) : "",
          };
        });

        let data = tinFormat;
        exportFromJSON({ data, exportType });
      });
  };

  const handleTin = (e) => {
    const options = e.target.value;
    console.log(options);
    setTinType(options);
    setTinOptions(options)

    setLoad(true);
    axios
      .get(
        "/manageTin/RandomTin/" +
          localStorage.getItem("user.id") +
          `/TinType/${options}` + `/candidateId/${candidateId}`, // add candidate id in this api
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res, err) => {
        if (res.status === 200) {
          setError("");
          disableTinArrangeButton("");
          getTinReport();
          setTin(res.data.status);
        }
      })
      .catch((err) => {
        console.error(err)
        disableTinArrangeButton(err?.response?.data?.status);
        message.error(err?.response?.data?.status ? err?.response?.data?.status : "data " + err?.response?.statusText , 5);
        setError(err?.response?.data?.status);
        setTin("")
      })
      .finally(() => {
        setLoad(false);
      });
  };

  return (
    <div>
      <label>TIN</label>
      {load ? (
        <Spin tip="Loading">
          <div className="content" />
        </Spin>
      ) : (
        <div>
          <select className="form-control" onChange={handleTin} value={tinType}>
            <option value="">Select Tin Type</option>
            <option value="Voice">Voice</option>
            <option value="Written">Written</option>
          </select>
          <br />
          <input
            placeholder="Enter Status"
            value={tin?.tinNo ? tin?.tinNo : error}
            type="text"
            //  onChange={handleInputEditStatus}
            disabled
            class="form-control"
            id="usr"
          />
          {/* {!error && (
            <div className="my-2 d-flex justify-content-between align-items-center">
              <span>
                <a
                  countData="countData"
                  onClick={(e) => {
                    toggle(e);
                  }}
                  style={{ color: "Blue" }}
                >
                  Count({tinReport?.tinCount}){" "}
                </a>
              </span>
              <button
                tinReq="tinReq"
                onClick={(e) => {
                  toggle(e);
                }}
                className="btn-sm btn-primary"
              >
                Request For New TIN
              </button>
              <button
                style={{ backgroundColor: "grey", color: "white" }}
                title="copy TIN"
                onClick={() => navigator.clipboard.writeText(tin?.tinNo)}
                className="btn-sm"
              >
                <CopyOutlined /> Copy
              </button>
            </div>
          )} */}
        </div>
      )}

      <Modal size={toggleModal ? "xl" : ""} isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {/* <div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 25px",
            }}
          >
            {toggleModal ? "TIN Report" : "Request For New Tin"}
            {toggleModal && (
             
              <div>
                {" "}
                
              </div>
            )}
          </div>
          {/* </div> */}
        </ModalHeader>
        <ModalBody>
          {toggleModal ? (
            <div className="card-body row p-3 border mb-2 bg-white cursor-pointer shadow-sm ">
              <table className="table bg-white ">
                <thead>
                  <tr>
                    <th>Interviewer Name</th>
                    <th>Candidate Name</th>
                    <th>Email</th>
                    <th>TIN No</th>
                    <th>TIN Type</th>
                    <th>Created-At</th>
                    <th>TRF</th>
                    <th>Location</th>
                    <th>Process</th>
                  </tr>
                </thead>
                <tbody>
                  {tinReport?.tinList?.map((ele) => {
                    return (
                      <tr>
                        <td>{ele?.assignUserId?.name}</td>

                        <td>{ele?.candidateId?.name}</td>
                        <td>{ele?.assignUserId?.email}</td>
                        <td>{ele?.tinNo}</td>
                        <td>{ele?.tinType}</td>
                        <td>
                          {ele?.createdAt ? formatDate(ele?.createdAt) : ""}
                        </td>
                        <td>{ele?.candidateId?.trf?.title}</td>
                        <td>{ele?.candidateId?.trf?.location}</td>
                        <td>{ele?.candidateId?.trf?.processName}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <Pagination
                current={current}
                onChange={onChange}
                total={tinReport?.tinCount}
              />
            </div>
          ) :
           (
            <div className="form-group">
              {errorRequestTin && (
                <Alert type="error" message={errorRequestTin} banner />
              )}
              <label>TIN No- {tin?.tinNo}    <b style={{color: "green"}}>{tinType} type</b></label>
              {/* <label>{tinType}</label> */}
              <select
                id="FormType"
                className="mb-2 form-control"
                onChange={selectReason}
                value={reason}
              >
                <option value="" selected="true">
                  Select Reason
                </option>

                <option
                  //selected
                  value={"Failed"}
                >
                  Failed
                </option>
                <option
                  //selected
                  value={"Tech issue"}
                >
                  Tech issue
                </option>
                <option
                  //selected
                  value={"Already Used"}
                >
                  Already Used
                </option>
              </select>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          {!toggleModal && (
            <div>
              <Button color="primary" onClick={requestNewTin}>
                Submit
              </Button>{" "}
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
            </div>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default TinAssign;
